import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';

@Component({
    selector: 'app-enterprise-wallet-balance',
    templateUrl: './enterprise-wallet-balance.component.html',
    styleUrls: ['./enterprise-wallet-balance.component.css']
})
export class EnterpriseWalletBalanceComponent implements OnInit {
    id!: string;

    sessionUser$ = this.loginService.sessionUser.asObservable();

    constructor(
        public loginService: LoginService,
    ) { }

    ngOnInit(): void {

        this.sessionUser$
            .pipe(take(1))
            .subscribe((user) => {
                if (user?.enterprise) {
                    this.id = user.enterprise.enterpriseId;
                }
            });
    }
}
